/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { StyledText } from "../../../assets/typography/typography";
import { colors } from "../../../components/colors";
import { InLineLabel } from "../../../components/Label";

const infoStyle = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const headerWrapperStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

type Props = {
  title: string;
  subtitle: string;
  currentIsActive: boolean;
  isDisabled: boolean;
};

export const ChallengeCollapseHeader = ({
  title,
  subtitle,
  currentIsActive,
  isDisabled,
}: Props) => {
  return (
    <div css={infoStyle}>
      <div css={headerWrapperStyle}>
        <StyledText
          color={colors.textPrimary}
          className="bodyTextSemibold mb-0"
        >
          {title}
        </StyledText>
        <InLineLabel
          backgroundColor={
            isDisabled
              ? colors.errorLight
              : currentIsActive
              ? colors.successLight
              : colors.ctaInactive
          }
          color={
            isDisabled
              ? colors.errorDark
              : currentIsActive
              ? colors.successDark
              : colors.textPrimary
          }
        >
          {isDisabled ? "Disabled" : currentIsActive ? "Active" : "Inactive"}
        </InLineLabel>
      </div>
      <StyledText
        color={colors.textSecondary}
        className="bodySubtextRegular mb-0"
      >
        {subtitle}
      </StyledText>
    </div>
  );
};
